import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.otpRequirementChecked = false
  }

  handleSubmit(event) {
    if (this.otpRequirementChecked || !$('#otp-group').hasClass('d-none')) return true
    
    event.preventDefault()
    const email = $('#user_email').val(), password = $('#user_password').val()
    this.otpRequirementChecked = true

    $.ajax({
      url: '/users/check_2fa',
      method: 'POST',
      data: { user: { email: email, password: password } },
      headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
      success: (result) => {
        if (result.requires_2fa) {
          $(".alert").alert().hide()
          this.showOtpField()
        } else { 
          this.element.submit()
        }
      },
      error: (xhr) => {
        this.element.submit()
      }
    })
  }
  
  showOtpField() {
    $('#otp-group').removeClass('d-none')
    $('#user_otp_attempt').prop('required', true)
    if ($("#user_password").val().length > 0) {
      $("#user_otp_attempt").focus()
    } else {
      $("#user_password").focus()
    }
    $('input[type="submit"]').val('Verify & Sign In')
    $('input[type="submit"]').attr('disabled', false)
  }
}
